import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-failed-check-out',
  templateUrl: './failed-check-out.component.html',
  styleUrls: ['./failed-check-out.component.css']
})
export class FailedCheckOutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
